import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import VivahLogo from './VivahLogo';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  return (
    <header className="pourkas-nav-wrapper">
      {/* Tier 1: Top Direct Contact & Status Bar */}
      <div className="nav-top-bar">
        <div className="nav-top-left">
          <span className="nav-top-pill">
            💍 Matrimony: <a href="tel:9857074103"><strong>Laxmikant Timilsina (9857074103)</strong></a>
          </span>
          <span className="nav-top-sep">|</span>
          <span className="nav-top-pill">
            🍽️ Catering &amp; Decor: <a href="tel:9867155395"><strong>Krishna Khanal (9867155395)</strong></a>
          </span>
        </div>
        <div className="nav-top-right">
          <span className="nav-top-pill">
            📍 Yogikuti, Butwal, Nepal
          </span>
          <span className="nav-top-sep">|</span>
          <span className="nav-top-pill">
            💻 <a href="https://pourkas.org" target="_blank" rel="noopener noreferrer"><strong>pourkas.org</strong></a>
          </span>
        </div>
      </div>

      {/* Tier 2: Main Navigation Bar */}
      <nav className="nav-main-bar">
        {/* Brand Logo & Title */}
        <Link to="/" className="nav-brand" onClick={() => setMenuOpen(false)}>
          <VivahLogo size="small" />
          <div className="nav-brand-text">
            <span className="nav-brand-name">Vivah Nepal</span>
            <span className="nav-brand-sub">Marriage Consultation &amp; Royal Events</span>
          </div>
        </Link>

        {/* Desktop Navigation Links */}
        <div className="nav-links-desktop">
          <Link to="/consultation" className={`nav-link${isActive('/consultation') ? ' nav-link--active' : ''}`}>
            💍 Matrimony Registry
          </Link>
          <Link to="/catering" className={`nav-link${isActive('/catering') ? ' nav-link--active' : ''}`}>
            🍽️ Catering &amp; Decor
          </Link>
          <Link to="/contact" className={`nav-link${isActive('/contact') ? ' nav-link--active' : ''}`}>
            📍 Offices &amp; Support
          </Link>
        </div>

        {/* Right side: Auth State + Actions */}
        <div className="nav-right">
          {user ? (
            <div className="nav-user-actions">
              <button 
                className="nav-user-badge-btn"
                onClick={() => navigate('/consultation/profile')}
                title="View My Profile"
                style={{
                  borderColor: '#2e7d32',
                  color: '#1b5e20',
                  background: '#e8f5e9'
                }}
              >
                ✓ {user.full_name || user.username}
              </button>
              <button 
                className="nav-logout-btn"
                onClick={logout}
                title="Log Out"
              >
                Logout
              </button>
            </div>
          ) : (
            <div className="nav-guest-actions">
              <Link to="/consultation/login" className="nav-link-login">
                Log In
              </Link>
              <button className="btn btn-primary btn-sm nav-cta-btn" onClick={() => navigate('/consultation/register')}>
                Free Registration →
              </button>
            </div>
          )}

          {/* Hamburger toggle for mobile */}
          <button
            className={`nav-hamburger${menuOpen ? ' nav-hamburger--open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation menu"
            aria-expanded={menuOpen}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile Dropdown Menu */}
      <div className={`nav-mobile-menu${menuOpen ? ' nav-mobile-menu--open' : ''}`}>
        <Link to="/consultation" className={`nav-mobile-link${isActive('/consultation') ? ' nav-mobile-link--active' : ''}`}>
          💍 Matrimony Registry
        </Link>
        <Link to="/catering" className={`nav-mobile-link${isActive('/catering') ? ' nav-mobile-link--active' : ''}`}>
          🍽️ Catering &amp; Decor
        </Link>
        <Link to="/contact" className={`nav-mobile-link${isActive('/contact') ? ' nav-mobile-link--active' : ''}`}>
          📍 Offices &amp; Support
        </Link>
        {user ? (
          <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <div style={{
              padding: '0.6rem 0.8rem',
              background: '#e8f5e9',
              color: '#2e7d32',
              borderRadius: '12px',
              fontSize: '0.86rem',
              fontWeight: 700
            }}>
              ✓ Member: {user.full_name || user.username}
            </div>
            <button className="btn btn-primary btn-full" onClick={() => { navigate('/consultation/profile'); setMenuOpen(false); }}>
              View My Marriage Profile
            </button>
            <button className="btn btn-tertiary btn-full" style={{ color: '#9E1B32', borderColor: '#9E1B32' }} onClick={() => { logout(); setMenuOpen(false); }}>
              Log Out
            </button>
          </div>
        ) : (
          <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <button className="btn btn-primary btn-full nav-mobile-cta" onClick={() => { navigate('/consultation/register'); setMenuOpen(false); }}>
              Free Profile Registration →
            </button>
            <button className="btn btn-tertiary btn-full" style={{ color: '#1C1014', borderColor: '#E8DFD1' }} onClick={() => { navigate('/consultation/login'); setMenuOpen(false); }}>
              Log In to Existing Profile
            </button>
          </div>
        )}
        <div className="nav-mobile-contacts">
          <a href="tel:9857074103">💍 Laxmikant: 9857074103</a>
          <a href="tel:9867155395">🍽️ Krishna: 9867155395</a>
        </div>
      </div>
    </header>
  );
}
